import React, { useEffect } from "react";
import _ from "lodash";

import {
  AppBody,
  AppContent,
  AppContentWrapper,
} from "@nokia-csf-uxr/ccfk/App";
import DotHeader from "Components/Header";
import "../styles/Dashboard.css";

import HeaderToolbar from "features/dashboard/components/Common/HeaderToolbar";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState, store } from "Store/mainStore";
import CaseContent from "./CaseContent";
import CasePagination from "./CasePagination";
// import { fetchUsers } from "../services/dashboaardThunks";
import { fetchOffer,fetchUserFavourites } from "../services/dashboaardThunks";
import { LandingPage } from "features/dashboard/components/Common/LandingPage";
import { useAuthState } from "Components/Logics/ensoCommonFunctions";
import AlertDialogModal from "App/AlertDialogModal";
import { setStateRestoreFlag } from "Store/general/auth";
import { handleCasePageReset } from "Constants/services/common";

const DashboardHome = () => {
  useAuthState();
  // Sectors
  const dashboardSelector = useSelector((state: RootState) => state.dashboard);
  // Hooks
  const dispatch = useDispatch<AppDispatch>();

  // Reset the state when the component mounts
  useEffect(() => {
    // Reset the state
    dispatch(setStateRestoreFlag({ isOfferDataRestored: false }));
    // Reset the case page
    handleCasePageReset(dispatch);
  },[]);


  useEffect(() => {
    // Need to update the below condition
    // for all_cases selected status is not required
    if (_.includes(['all_cases','my_cases'],dashboardSelector.data?.caseType) && dashboardSelector.data?.["selectedSortOption"]?.["key"]) {
      const offerFilterObj = {
        offerType: dashboardSelector.data?.filterTab,
        caseType: dashboardSelector.data?.caseType,
        itemsPerPage: dashboardSelector.data?.pagination?.["itemsPerPage"],
        currentPage: dashboardSelector.data?.pagination?.["currentPage"],
        sortOption: dashboardSelector.data?.["selectedSortOption"]?.["key"],
        offerSearch: dashboardSelector.data?.["offerSearch"],
        offerStatus: dashboardSelector.data?.["selectedStatus"],
      };
      // Below condition is to avoid multiple calls for fetching offers
      if((dashboardSelector.data?.caseType === 'my_cases' && dashboardSelector.data?.["selectedStatus"]?.length > 0) || 
         (dashboardSelector.data?.caseType === 'all_cases' && dashboardSelector.data?.["selectedStatus"]?.length === 0)) {
        // Trigger the fetchOffer action with the constructed filter object
        dispatch(fetchOffer(offerFilterObj));
      }
    }
    if(dashboardSelector?.data?.caseType === 'favourites' && dashboardSelector.data?.["selectedSortOption"]?.["key"]) {
      const offerFilterObj = {
        // offerType: dashboardSelector.data?.filterTab,
        caseType: dashboardSelector.data?.caseType,
        itemsPerPage: dashboardSelector.data?.pagination?.["itemsPerPage"],
        currentPage: dashboardSelector.data?.pagination?.["currentPage"],
        sortOption: dashboardSelector.data?.["selectedSortOption"]?.["key"],
        offerSearch: dashboardSelector.data?.["offerSearch"],
      };
      dispatch(fetchUserFavourites(offerFilterObj));
    }
  }, [
    dispatch,
    dashboardSelector.data?.caseType,
    // dashboardSelector.data?.filterTab,
    dashboardSelector.data?.["selectedStatus"],
    dashboardSelector.data?.pagination?.["itemsPerPage"],
    dashboardSelector.data?.pagination?.["currentPage"],
    dashboardSelector.data?.["selectedSortOption"]?.["key"],
    dashboardSelector.data?.["offerSearch"],
    dashboardSelector.data?.favourites?.total_count,
    dashboardSelector.data?.["clonedOffer"]
  ]);

  return (
    <div>
      <DotHeader />
      <AppBody>
        <AppContentWrapper
          style={{
            paddingLeft: "1rem",
            paddingRight: "1rem",
          }}
        >
          <HeaderToolbar />
          <AppContent
            style={{
              padding: "0",
              width: "100%",
              overflow: "hidden",
            }}
          >
            {!dashboardSelector.data?.caseType && (
              <LandingPage />
            )}

            {dashboardSelector.data?.caseType && (
              <>
                <CaseContent />
                <CasePagination />
              </>
            )}
            <AlertDialogModal />
          </AppContent>
        </AppContentWrapper>
      </AppBody>
    </div>
  );
};

export default DashboardHome;
